import Layout from '@/apps/layout/components'
import WhatToReadDetail from '@/apps/WhatToReadDetail'
import React from 'react'

const WhatToReadDetailPage = (): React.ReactElement => {
  return (
    <Layout>
      <WhatToReadDetail />
    </Layout>
  )
}

export default WhatToReadDetailPage
